// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"534":"2c256f4d","688":"5e8e23fe","847":"2c256f4d","902":"2c256f4d"}[chunkId] + ".chunk.css";
};